import { type SocialCause } from "@koala/sdk";
import { styled } from "@/components/content/stitches";
import { Image } from "@/components/image";
import { Stack } from "@/components/ui";
import { useConfigOverride } from "@/redux/cmsConfig";
import { getFontStyles } from "@/redux/cmsConfig/utils";

type Props = {
  onClick: (socialCauseId?: number) => void;
  isSelected?: boolean;
} & SocialCause;

export function SocialCauseItem({
  name,
  description,
  image_url,
  onClick,
  id,
  isSelected,
}: Props) {
  const { primary_border_color, border_radius, primary_active_color } =
    useConfigOverride("global");
  const { primary_font } = useConfigOverride("text");
  const { color } = getFontStyles(primary_font);

  const handleClick = () => {
    if (isSelected) {
      onClick();
    } else {
      onClick(id);
    }
  };

  return (
    <Stack
      data-testid="social-cause-item"
      onClick={handleClick}
      direction="vertical"
      align="center"
      position="center"
      css={{
        padding: "$4",
        border: `1px solid ${
          isSelected ? primary_active_color : primary_border_color
        }`,
        borderRadius: `${border_radius}px`,
        color,
        width: "100%",
      }}
    >
      <Stack align="center" position="leading" gap="$4" css={{ width: "100%" }}>
        {image_url ? (
          <Image
            src={image_url}
            width={50}
            height={50}
            alt={`${name ?? ""} social cause icon`}
          />
        ) : null}
        <h3>{name}</h3>
      </Stack>
      <Description>{description}</Description>
    </Stack>
  );
}

const Description = styled("p", {
  margin: 0,
});
